<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    content-class="sc-modal sc-modal--md"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :disabled="telas_descanso && telas_descanso.length >= 5"
        small
        color="primary"
        class="descanso-add-btn"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon small class="mr-1">mdi-plus</v-icon>
        Adicionar
      </v-btn>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <!-- Close -->
      <v-btn icon class="sc-modal__close" @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Header -->
      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-image-plus</v-icon>
        <div>
          <span class="sc-modal__title">Adicionar tela de descanso</span>
          <span class="sc-modal__subtitle">Imagem exibida quando não há conteúdo no mosaico</span>
        </div>
      </div>

      <!-- Upload area -->
      <div class="sc-modal__body">
        <div
          v-if="!file"
          class="sc-dropzone"
          @dragover.prevent="isDragging = true"
          @dragleave="isDragging = false"
          @drop.prevent="onDrop"
          :class="{ 'sc-dropzone--active': isDragging }"
          @click="$refs.fileInput.$el.querySelector('input').click()"
        >
          <v-icon size="40" :color="isDragging ? 'primary' : 'text_secondary'">
            mdi-cloud-upload-outline
          </v-icon>
          <span class="descanso-dropzone-title">
            Arraste uma imagem aqui
          </span>
          <span class="descanso-dropzone-subtitle">ou clique para selecionar</span>
          <span class="descanso-dropzone-formats">JPEG, PNG, JPG</span>
          <v-file-input
            ref="fileInput"
            accept="image/jpeg, image/png, image/jpg"
            style="display: none"
            @change="onChange"
          />
        </div>

        <!-- Preview -->
        <div v-if="file" class="descanso-preview">
          <div class="descanso-preview-image-wrap">
            <v-img
              :src="image_url"
              class="descanso-preview-image"
              aspect-ratio="1.6"
              cover
            >
              <template v-slot:placeholder>
                <div class="d-flex align-center justify-center fill-height">
                  <v-progress-circular indeterminate color="primary" />
                </div>
              </template>
            </v-img>
            <v-btn
              icon
              small
              class="descanso-preview-remove"
              @click="removeFile()"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="descanso-preview-info">
            <v-icon small color="primary" class="mr-2">mdi-image-check</v-icon>
            <span class="descanso-preview-name">{{ file.name }}</span>
            <span class="descanso-preview-size">{{ formatSize(file.size) }}</span>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="sc-modal__footer">
        <v-btn text @click="close()" class="modal-btn-cancel">
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          :loading="isLoading"
          :disabled="!file"
          @click.prevent="inserirTelaDescanso()"
          class="modal-btn-confirm"
        >
          <v-icon small class="mr-1">mdi-check</v-icon>
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from '@/services/api';
import { mapGetters } from 'vuex';

export default {
  name: "ModalAdicionarTelaDescanso",
  data() {
    return {
      dialog: false,
      isLoading: false,
      isDragging: false,
      file: null,
      image_url: null,
      accepted_image_types: [
        "image/png",
        "image/jpeg",
        "image/jpg",
      ],
    };
  },
  props: {
    cod_producao: Number,
    getTelasDescanso: Function,
  },
  computed: {
    ...mapGetters({
      telas_descanso: 'telas_descanso/getTelasDescanso',
    }),
  },
  methods: {
    formatSize(bytes) {
      if (!bytes) return '';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    },
    onDrop(e) {
      this.isDragging = false;
      const droppedFile = e.dataTransfer.files[0];
      if (droppedFile) {
        this.processFile(droppedFile);
      }
    },
    onChange(e) {
      if (e) {
        this.processFile(e);
      }
    },
    processFile(file) {
      if (!this.accepted_image_types.includes(file.type)) {
        return this.$toast.error('Formato não aceito. Selecione JPEG, PNG ou JPG.');
      }
      this.file = file;
      this.image_url = URL.createObjectURL(this.file);
    },
    close() {
      this.revokeUrl();
      this.dialog = false;
      this.file = null;
      this.image_url = null;
    },
    revokeUrl() {
      if (this.image_url && this.image_url.startsWith('blob:')) {
        URL.revokeObjectURL(this.image_url);
      }
    },
    removeFile() {
      this.revokeUrl();
      this.file = null;
      this.image_url = null;
    },
    transformFileNameToUniqueName(fileName, data_hoje) {
      const miliseconds = data_hoje.getMilliseconds();
      const formatedFileName = data_hoje
        .toLocaleString("pt-BR", {
          month: "numeric",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
        })
        .replaceAll(",", "")
        .replaceAll("/", "")
        .replaceAll(":", "")
        .replaceAll(" ", "")
        .concat("-", String(miliseconds))
        .concat("-", fileName);
      return formatedFileName;
    },
    async inserirTelaDescanso() {
      try {
        this.isLoading = true;
        const dat_midia_colaboracao = new Date();
        const fileName = this.transformFileNameToUniqueName(this.file.name, dat_midia_colaboracao);

        await apiClient.post(
          "/uploadFileToGCP",
          { file: this.file, subpasta: "capas", fileName },
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        const url_midia = await this.getBucketImages(fileName, "capas");
        const payload = {
          cod_producao: this.cod_producao,
          url_midia,
          dat_midia_colaboracao,
          dsc_midia: fileName,
        };

        const response = await apiClient.post('/inserirProducaoTelaDescanso', payload);

        if (response.status === 200) {
          await this.getTelasDescanso();
          this.close();
          this.$toast.success('Imagem inserida com sucesso');
        }
      } catch (error) {
        this.$toast.error('Erro ao inserir tela de descanso.');
      } finally {
        this.isLoading = false;
      }
    },
    async getBucketImages(fileName, subpasta) {
      try {
        const response = await apiClient.get(
          `/getBucketImages?fileName=${fileName}&subpasta=${subpasta}`
        );
        if (response.status === 200) {
          return response.data.url;
        }
      } catch (error) {
        this.$toast.error('Erro ao obter URL da imagem.');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.descanso-add-btn {
  text-transform: none;
  font-weight: var(--sc-weight-semi);
  letter-spacing: 0;
  border-radius: var(--sc-radius-md);
}

.descanso-dropzone-title {
  font-size: 0.95rem;
  font-weight: var(--sc-weight-semi);
  color: var(--v-text_primary-base);
  margin-top: 4px;
}

.descanso-dropzone-subtitle {
  font-size: var(--sc-text-lg);
  color: var(--v-text_secondary-base);
}

.descanso-dropzone-formats {
  font-size: var(--sc-text-sm);
  color: var(--v-text_secondary-base);
  background: var(--sc-surface-tint-hover);
  padding: 2px 10px;
  border-radius: 4px;
  margin-top: 8px;
  letter-spacing: var(--sc-tracking-caps);
}

.descanso-preview {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.descanso-preview-image-wrap {
  position: relative;
  border-radius: var(--sc-radius-lg);
  overflow: hidden;
}

.descanso-preview-image {
  border-radius: var(--sc-radius-lg);
  max-height: 280px;
}

.descanso-preview-remove {
  position: absolute !important;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.5) !important;
  backdrop-filter: blur(4px);

  &:hover {
    background: rgba(var(--sc-color-error-rgb),0.7) !important;
  }
}

.descanso-preview-info {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: rgba(var(--sc-color-primary-rgb),0.06);
  border: 1px solid rgba(var(--sc-color-primary-rgb),0.15);
  border-radius: var(--sc-radius-md);
}

.descanso-preview-name {
  font-size: var(--sc-text-base);
  color: var(--v-text_primary-base);
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.descanso-preview-size {
  font-size: var(--sc-text-md);
  color: var(--v-text_secondary-base);
  margin-left: 8px;
}
</style>
